module.exports = __webpack_public_path__ + "img/nft.5668677e.png";